export const SET_VENUE_OFFLINE = 'app/Venue/SET_VENUE_OFFLINE';
export const LOADING_FULFILMENT_TIMESLOTS = 'app/Venue/LOADING_FULFILMENT_TIMESLOTS';
export const SET_FULFILMENT_TIMESLOTS = 'app/Venue/SET_FULFILMENT_TIMESLOTS';
